import { useCallback } from 'react';
import { edmCampaign } from '@bingads-webui/edm-campaign';

export const useSearchLocationData = (scope) => {
  const getLocation = useCallback((search) => {
    const { aid, cid } = scope.values;
    return edmCampaign.Customers.$withKey(cid).Accounts.$withKey(aid).Locations.get({
      select: ['ParentLocations'],
      search,
    }).toPromise()
      .then(response => response)
      .catch(error => Promise.reject(error));
  }, [scope]);

  return {
    getLocation,
  };
};
